import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setSatIdentificationCollection = async (context) => {
  const { data } = await api().post('fiscal.sat-allowed-identifications');
  const collection = data.map((e) => ({ ...e, text: e.descricao, value: e }));
  context.commit(types.SET_SAT_IDENTIFICATION_COLLECTION, collection);
};
